<template>
  <main-content-layout title="공지사항" img-src="notice_carousels_icon.png">
    <template v-slot:button>
      <div class="carousel-buttons-layout">
        <v-img
          class="carousel-button"
          :src="require(`@/assets/images/icons/carousels_left_icon.png`)"
          @click="prevCategory"
        />
        <v-img
          class="carousel-button"
          :src="require(`@/assets/images/icons/carousels_right_icon.png`)"
          @click="nextCategory"
        />
      </div>
    </template>
    <template v-slot:content>
      <v-row
        class="notice-carousels-layout"
        align="stretch" dense justify="start"
      >
        <v-col
          cols="12"
          v-for="(item, index) in categoryList" :key="index"
          v-show="index === currentCategoryIndex"
        >
          <div class="notice-carousels-title-layout">
            <span class="notice-carousels-title">
              {{ item.categoryNm }}
            </span>
            <span class="notice-carousels-seemore" @click="seeMoreCategory(item)">
              더보기
            </span>
          </div>
          <ul
              class="board-list"
              :class="{
                      'all-notice': board_item.noticeLevel === 3,
                      'type-notice': board_item.noticeLevel === 2,
                      'normal-notice': board_item.noticeLevel === 1,
                      'none-notice': board_item.title === ''
                    }"
              v-for="(board_item, board_index) in item.boardList" :key="board_index"
              @click="showBoardDetail(item, board_item)"
          >
            <li
                class="board"
                :class="{
                        'all': board_item.noticeLevel === 3,
                        'type': board_item.noticeLevel === 2,
                        'normal': board_item.noticeLevel === 1
                      }"
            >
              <span class="board-title">
                {{ overLengthText(board_item.title, boardTitleMaxLength) }}
              </span>
            </li>
          </ul>
        </v-col>
      </v-row>
    </template>
  </main-content-layout>
</template>

<script>
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import router from "@/router";
import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "NoticeCarousels",
  components: {MainContentLayout},
  mixins: [TableMixin],
  data() {
    return {
      categoryList: [],
      boardList: [],
      currentCategoryIndex: 0,
      deviceWidth: 0,
      boardMaxLength: 0,
      boardTitleMaxLength: 0
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  mounted() {
    this.getBoardCategory();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.deviceWidth = window.innerWidth;
      if (this.deviceWidth < 768) {
        this.boardMaxLength = 4;
        this.boardTitleMaxLength = 16;
      }
      if (this.deviceWidth >= 768) {
        this.boardMaxLength = 7;
        this.boardTitleMaxLength = 20;
      }
      if (this.deviceWidth >= 1024) {
        this.boardMaxLength = 9;
      }
      if (this.deviceWidth >= 1264) {
        this.boardTitleMaxLength = 30;
      }
    },
    async getBoardCategory() {
      try {
        const { data } = await axiosInstance.get("/private/board/category", {
          params: {
            memberId: this.memberId,
            useYn: "Y"
          }
        });
        if (data.length < 1) {
          this.categoryList = [];
          return false;
        }
        else {
          this.categoryList = data;
          await this.getBoardList(data[0].categoryId);
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }

    },
    async getBoardList(categoryId) {
      try {
        await axiosInstance.get("/private/board/board-list", {
          params: {
            categoryId: categoryId,
            searchNm: "",
            searchType: "ALL"
          }
        }).then((response) => {
          let resultList = this.listFiller(response.data);
          this.$set(this.categoryList[this.currentCategoryIndex], "boardList", resultList);
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    listFiller(list) {
      let replaceList = [...list];
      if (list.length > this.boardMaxLength) {
        return list.slice(0, this.boardMaxLength);
      } else {
        const missingCount = this.boardMaxLength - list.length; // 숫자 타입
        for (let i = 0; i < missingCount; i++) {
          replaceList.push({noticeLevel: 1, title: "", createDate: "" });
        }
        return replaceList;
      }
    },
    prevCategory() {
      if (this.currentCategoryIndex === 0) {
        this.currentCategoryIndex = this.categoryList.length - 1;
      } else {
        this.currentCategoryIndex -= 1;
      }
      for (let index = 0; index < this.categoryList.length; index++) {
        if (this.currentCategoryIndex === index) {
          this.getBoardList(this.categoryList[index].categoryId);
        }
      }
    },
    nextCategory() {
      if (this.currentCategoryIndex === this.categoryList.length - 1) {
        this.currentCategoryIndex = 0;
      } else {
        this.currentCategoryIndex += 1;
      }
      for (let index = 0; index < this.categoryList.length; index++) {
        if (this.currentCategoryIndex === index) {
          this.getBoardList(this.categoryList[index].categoryId);
        }
      }
    },
    seeMoreCategory(item) {
      sessionStorage.setItem("boardDetailList", JSON.stringify(item));
      router.push({name: "BoardTable", params: {categoryId: item.categoryId}});
    },
    showBoardDetail(item, boardItem) {
      if (boardItem.title === "") return false;
      sessionStorage.setItem("boardDetailList", JSON.stringify(item));
      sessionStorage.setItem("boardDetail", JSON.stringify(boardItem));
      router.push({name: "BoardDetail", params: {boardId: boardItem.boardId}});
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-buttons-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  .carousel-button {
    margin: 0 5px;
    width: min(6vw, 30px);
  }
  .carousel-button:hover {
    cursor: pointer;
  }
}

.notice-carousels-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  .notice-carousels-title-layout {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    .notice-carousels-title {
      font-size: min(4vw, 24px);
      font-weight: bold;
    }
    .notice-carousels-seemore {
      font-size: min(3vw, 18px);
    }
    .notice-carousels-seemore:hover {
      cursor: pointer;
    }
  }
  // ul
  .board-list {
    display: flex;
    justify-content: space-between;
    padding: 3px 10px;
    font-size: min(3.5vw, 18px);
    border-bottom: 1px solid #e0e0e0;
    background-color: #ffffff;
    // li
    .board {
      height: 25px;
      .board-title {
      }
    }
  }
  .board-list.all-notice,
  .board-list.type-notice {
    list-style: none;
    padding-left: 5px;
    .board.all::before {
      content: "공지";
      color: white;
      font-weight: bold;
      border: 1px solid #BF0013;
      border-radius: 5px;
      margin-right: 5px;
      padding: 0 10px;
      background-color: #BF0013;
    }
    .board.type::before {
      content: "공지";
      color: white;
      font-weight: bold;
      border: 1px solid #28A7E1;
      border-radius: 5px;
      margin-right: 5px;
      padding: 0 10px;
      background-color: #28A7E1;
    }
    .board.all,
    .board.type {
      font-weight: bold;
    }
    //.board.all {
    //  color: #BF0013;
    //}
    //.board.type {
    //  color: #28a7e1;
    //}
  }
  .board-list.normal-notice {
    padding-left: 15px;
    list-style: none;
    .board.normal::before {
      content: "";
    }
  }
  .board-list.none-notice {
    list-style: none;
  }
  .board-list:hover {
    cursor: pointer;
  }
  .board-list.none-notice:hover {
    cursor: default;
  }
}
</style>